import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function OccurrenceHistory({ data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const historyChart = useMemo(() => {
        const source = Array.isArray(data?.temp_analysis)
            ? data.temp_analysis.filter(item => item?.source === "history")
            : [];

        const labels = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

        const yearMap = new Map();

        for (const item of source) {
            const year = String(item?.h_year ?? "");
            const month = Number(item?.h_month ?? 0);
            const qty = Number(item?.qty ?? 0);

            if (!year || month < 1 || month > 12) continue;

            if (!yearMap.has(year)) {
                yearMap.set(year, new Array(12).fill(0));
            }

            yearMap.get(year)[month - 1] = qty;
        }

        const dataColumns = Array.from(yearMap.entries()).map(([year, months]) => [year, ...months]);

        return {
            labels,
            dataColumns,
        };
    }, [data]);

    useEffect(() => {
        if (!historyChart.labels.length) return;

        GraphicUtils.lineChart(
            "occurrence-history-chart",
            historyChart.dataColumns,
            historyChart.labels,
        );
    }, [historyChart]);

    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Histórico de ocorrências</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id="occurrence-history-chart"/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>
            <div className="chart-divisor"/>
        </>
    )
}